import React from 'react';
import moment from 'moment';
import { Link } from 'react-router';

export default function Planned(props) {
  const { data, caseDate, onAddSelectedProduct } = props;
  const _onAddSelectedProduct = (selectedData) => {
    onAddSelectedProduct(selectedData);
  };

  return (
    <div className="sets-list-blocks p-0">
      <div className="sets-block">
        {Object.keys(data).length > 0 ? Object.keys(data)
          .map((value, index) => (
            <div className="sets-block" key={index}>
              <h4>
                <span className={`'acm-planned-component' ${value === 'null' ? 'text-hidden' : ''}`} style={{ textTransform: 'capitalize' }}>
                  {value === '' ? 'No Component' : (value !== 'undefined' ? value : 'No Component')}
                </span>
              </h4>
              <ul className="list-unstyled">
                {
                  data[value].map((acmProduct, key) => (
                    <li className="pt-1 pb-1" key={key} style={{ borderTop: '0' }}>
                      <div className="contents-wrap">
                        <div className="row gx-2">
                          <div className="col-auto">
                            <div className="left-icon">
                              {moment(caseDate) >= moment() ? (
                                <Link onClick={() => _onAddSelectedProduct(acmProduct)}>
                                  <i className="fas fa-plus theme-color cursor-pointer" />
                                </Link>
                              ) : ''}
                            </div>
                          </div>
                          <div className="col">
                            <div className="row gx-2">
                              <div className="col">
                                <p>{acmProduct.productId}</p>
                              </div>
                              <div className="col text-center">
                                {acmProduct.confidence > 0
                                  && (
                                    <p className={acmProduct.maxValue === acmProduct.confidence
                                      ? 'confidence-max-value' : ''}
                                    >AI {acmProduct.confidence}%
                                    </p>
                                  )}
                              </div>
                              <div className="col text-end">
                                <p>{acmProduct.isTemplated === 'false' ? 'Templated' : ''}</p>
                              </div>
                            </div>
                            <p>{acmProduct.ProductDescription}</p>
                          </div>
                        </div>
                      </div>
                    </li>
                  ))
                }
              </ul>
            </div>
          )) : <p className="text-center mt-5">There are no planned products for this case.</p>}
      </div>
    </div>
  );
}
